import React from 'react';
import { Body, Header, Main } from '../NecttosComp/Layout/Layout';
import Button from '../NecttosComp/Button/Button';
import { motion } from 'framer-motion';
import { useQuery } from 'react-query';
import { getAxiosInstance } from '../utils/axiosInstance';
import { OLoading } from '../static/svg/icons';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

function Instruction({ keyId, width = '' }) {
	const [state, setState] = React.useState('button');
	const [expanded, setExpanded] = React.useState(null);

	const { data, isFetching } = useQuery(
		['getInstructions', keyId],
		async () => {
			try {
				const instance = getAxiosInstance();
				const { data } = await instance.get(`/college/office/documentation/getItem/${keyId}`);
				if (data.statusCode === 400) {
					throw new Error(data.message || 'API Error');
				} else {
					return data?.data;
				}
			} catch (error) {
				console.log(error);
			}
		},
		{
			refetchOnWindowFocus: false,
			refetchOnMount: false,
			refetchOnReconnect: false,
		},
	);

	const toggleExpand = (index) => {
		setExpanded(expanded === index ? null : index);
	};

	const renderPoint = (point, pointIndex) => {
		console.log(point);

		if (typeof point === 'object') {
			return (
				<li key={pointIndex} className='text-lg text-indigo-700 list-none'>
					{point?.text}
					<ul className='ml-6 list-disc space-y-1'>
						{point?.subpoints?.map((subPoint, subPointIndex) => (
							<li key={subPointIndex} className='flex items-center text-base text-indigo-600'>
								<span className='mr-2'>•</span>
								{subPoint}
							</li>
						))}
					</ul>
				</li>
			);
		} else {
			return (
				<li key={pointIndex} className='text-lg text-indigo-700'>
					{point}
				</li>
			);
		}
	};

	switch (state) {
		case 'button':
			return (
				<Button width={width} type='fetch' onClick={() => setState('modal')}>
					Tutorial {isFetching && <OLoading styles={{ width: '10px', height: '10px' }} />}
				</Button>
			);
		case 'modal':
			return (
				<Main title={data?.title || 'Instructions'} width='90%' height='90%' zIndex='1000' onClick={() => setState('button')}>
					<Body>
						<div className='bg-gradient-to-br from-sky-50 to-white dark:from-gray-800 dark:to-gray-900 p-6 sm:p-10 rounded-3xl shadow-xl  mx-auto'>
							<h2 className='text-3xl font-extrabold text-sky-800 dark:text-white mb-6'>📄 {data?.title} – User Guide</h2>

							{data?.questions.map((item, index) => (
								<div key={index} className='mb-4  dark:bg-gray-800 rounded-xl shadow-md'>
									<motion.div className='flex items-center justify-between px-5 py-4 cursor-pointer bg-sky-100 dark:bg-gray-700 hover:bg-sky-200 dark:hover:bg-gray-600 transition-colors rounded-t-xl' onClick={() => toggleExpand(index)} whileHover={{ scale: 1.01 }}>
										<h3 className='text-lg sm:text-xl font-semibold text-sky-900 dark:text-white'>
											{index + 1}. {item.question}
										</h3>
										{expanded === index ? <FiChevronUp size={24} className='text-sky-700 dark:text-white' /> : <FiChevronDown size={24} className='text-sky-700 dark:text-white' />}
									</motion.div>
									{expanded === index && (
										<motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }} transition={{ duration: 0.25 }} className='px-6 py-4 text-sm text-gray-700 dark:text-gray-200 space-y-6'>
											<div className='flex space-y-4 dark:bg-gray-900 p-4 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700'>
												<div className='w-4/5 m-2'>
													{item.steps.map((step, stepIndex) => (
														<div key={stepIndex} className='space-y-4 dark:bg-gray-900 p-4 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 m-2'>
															<div className='flex items-start gap-3'>
																<div className='h-8 w-8 flex items-center justify-center bg-sky-600 text-white rounded-full text-sm font-bold shadow-md'>{stepIndex + 1}</div>
																<h4 className='text-sky-800 dark:text-sky-300 font-semibold text-base leading-snug'>{step.step}</h4>
															</div>

															<ul className='mt-2 space-y-4 ml-3'>
																{step.substeps?.map((sub, subIndex) => (
																	<li key={subIndex} className='relative border-l-4 border-sky-200 dark:border-sky-600 pl-4 text-base text-gray-800 dark:text-gray-300 font-medium'>
																		<div className='flex items-start gap-2'>
																			<span className='mt-1 text-sky-600 dark:text-sky-400'>▸</span>
																			<span>{sub.text}</span>
																		</div>

																		{sub.subpoints?.length > 0 && (
																			<ul className='mt-2 ml-6 text-sm text-gray-600 dark:text-gray-300 bg-sky-50 dark:bg-gray-800 border border-sky-100 dark:border-gray-700 rounded-lg p-3 space-y-2'>
																				{sub.subpoints.map((point, pointIndex) => (
																					<li key={pointIndex} className="pl-2 relative before:content-['⦿'] before:text-sky-400 before:absolute before:left-0 before:top-0" style={{ paddingLeft: '1.25rem' }}>
																						{point}
																					</li>
																				))}
																			</ul>
																		)}
																	</li>
																))}
															</ul>
														</div>
													))}
												</div>
												<div className='w-1/5 m-2'>
													<h2 className='text-xl font-extrabold text-sky-800 dark:text-white mb-6'>Complete Malayalam Walkthrough – Step-by-Step Guidance Included</h2>
													{item.videoLink && (
														<div className='mt-6 w-full flex justify-center'>
															<div className='w-full  rounded-lg overflow-hidden shadow-lg'>
																<iframe width='300' height='200' src={item.videoLink} title='YouTube video' frameBorder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowFullScreen></iframe>
															</div>
														</div>
													)}
												</div>
											</div>
										</motion.div>
									)}
								</div>
							))}
						</div>
					</Body>
				</Main>
			);
	}
}

export default Instruction;
